import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { CardMenu } from '@/components/ui/card';
    import Permission from '@/enums/Permission';
    import type { NavItem } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SystemCardMenu',
  setup(__props) {

    const navItems: NavItem[] = [
        {
            title: 'system.vat_deadlines_title',
            href: route('v2.vat-deadlines.index'),
            permissionLevel: Permission.SYSTEM_VIEW,
        },
        {
            title: 'system.data_fields_title',
            href: route('v2.data-fields.index'),
            permissionLevel: Permission.SYSTEM_VIEW,
        },
        {
            title: 'kube.page_header',
            href: route('v2.kube.index'),
            permissionLevel: Permission.SYSTEM_VIEW,
        },
        {
            title: 'activities.log_headline',
            href: route('v2.log.index'),
            permissionLevel: Permission.ACTIVITIES_VIEW,
        },
    ];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CardMenu), { items: navItems }))
}
}

})